const variables = require('../../../variables/Variables.js');
const apiUrl = variables.apiUrl;

export const singaporeStoreId = '620d286ec38181ef4d34fbfb';

function getStaticUrlAsync(id) {
    const fetchUrl = apiUrl + 'asset/url?id=' + id;
    return new Promise((resolve, reject) => {
        fetch(fetchUrl)
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    throw new Error('Fetch static asset url failed with code ' + response.status);
                }
            })
            .then(responseJson => resolve(responseJson))
            .catch(error => reject(error));
    });
}

export const NavMarkerSpriteName = Object.freeze({
    NORMALLEFT: 'NavMarkerNormalLeft',
    NORMALRIGHT: 'NavMarkerNormalRight',
    NORMALUP: 'NavMarkerNormalUp',
    NORMALDOWN: 'NavMarkerNormalDown',
    NORMALUPLEFT: 'NavMarkerNormalUpLeft',
    NORMALDOWNLEFT: 'NavMarkerNormalDownLeft',
    NORMALUPRIGHT: 'NavMarkerNormalUpRight',
    NORMALDOWNRIGHT: 'NavMarkerNormalDownRight',
    NORMALSTAIRSUP: 'NavMarkerNormalStairsUp',
    NORMALSTAIRSDOWN: 'NavMarkerNormalStairsDown',
    HOVERLEFT: 'NavMarkerHoverLeft',
    HOVERRIGHT: 'NavMarkerHoverRight',
    HOVERUP: 'NavMarkerHoverUp',
    HOVERDOWN: 'NavMarkerHoverDown',
    HOVERUPLEFT: 'NavMarkerHoverUpLeft',
    HOVERDOWNLEFT: 'NavMarkerHoverDownLeft',
    HOVERUPRIGHT: 'NavMarkerHoverUpRight',
    HOVERDOWNRIGHT: 'NavMarkerHoverDownRight',
    HOVERSTAIRSUP: 'NavMarkerHoverStairsUp',
    HOVERSTAIRSDOWN: 'NavMarkerHoverStairsDown',
    FADELEFT: 'NavMarkerFadeLeft',
    FADERIGHT: 'NavMarkerFadeRight',
    FADEUP: 'NavMarkerFadeUp',
    FADEDOWN: 'NavMarkerFadeDown',
    FADEUPLEFT: 'NavMarkerFadeUpLeft',
    FADEDOWNLEFT: 'NavMarkerFadeDownLeft',
    FADEUPRIGHT: 'NavMarkerFadeUpRight',
    FADEDOWNRIGHT: 'NavMarkerFadeDownRight',
    FADESTAIRSUP: 'NavMarkerFadeStairsUp',
    FADESTAIRSDOWN: 'NavMarkerFadeStairsDown'
});

export function getHeartFillUrlAsync() {
    return getStaticUrlAsync('HeartFill');
}

export function getHeartEmptyUrlAsync() {
    return getStaticUrlAsync('HeartEmpty');
}

export function getNavMarkerUrlAsync(spriteName) {
    return getStaticUrlAsync(spriteName);
}

export function getProductMarkerNormalAsync() {
    return getStaticUrlAsync('ProductMarkerNormal');
}

export function getProductMarkerHoverAsync() {
    return getStaticUrlAsync('ProductMarkerHover');
}

export function getVideoMarkerNormalAsync() {
    return getStaticUrlAsync('VideoMarkerNormal');
}

export function getModalCloseIconNormalAsync() {
    return getStaticUrlAsync('ModalCloseIconNormal');
}

export function getModalCloseIconHoverAsync() {
    return getStaticUrlAsync('ModalCloseIconHover');
}

export function getDragToSpinAsync() {
    return getStaticUrlAsync('DragToSpin');
}

export function getDragToSpinIconAsync() {
    return getStaticUrlAsync('DragToSpinIcon');
}

export function getFacebookAsync() {
    return getStaticUrlAsync('FacebookIcon');
}

export function getTwitterAsync() {
    return getStaticUrlAsync('TwitterIcon');
}

export function getVideoPlayAsync() {
    return getStaticUrlAsync('VideoPlay');
}

export function getObsessLogoAsync() {
    return getStaticUrlAsync('ObsessLogo');
}

export function getObsessUrlAsync() {
    return getStaticUrlAsync('ObsessUrl');
}

export function getWelcomeExploreUrlAsync() {
    return getStaticUrlAsync('WelcomeExplore');
}

export function getZoomIconUrlAsync() {
    return getStaticUrlAsync('ZoomIcon');
}


export function getDirectoryMenu() {
    let menuList = [
        {
            name: 'WOMAN',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: 'Bags & Accessories',
                    sceneId: variables.storeId === singaporeStoreId ? '620d2898c38181ef4d352789' : '60cb5c64ec1b14930d4ba92b',
                },
                variables.storeId !== singaporeStoreId &&
                {
                    name: 'Bags & Accessories Level 2',
                    sceneId: '60f0a7c1f2e43cc4d45f7262'
                },
                {
                    name: 'Ready-to-wear',
                    sceneId: variables.storeId === singaporeStoreId ? '620d2898c38181ef4d35277a' : '60f0a630c584ff71d102ca97'
                },
                {
                    name: 'Shoes',
                    sceneId: variables.storeId === singaporeStoreId ? '6213c6730b6a1d285d429df5' : '60f09dd0f2e43cc4d45f71ea'
                },
                variables.storeId !== singaporeStoreId &&
                {
                    name: 'Fitting Room',
                    sceneId: '60f0ad57c584ff71d102ca9e'
                }
            ]
        },
        {
            name: 'MAN',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: 'Bags & Accessories',
                    sceneId: variables.storeId === singaporeStoreId ? '620d2898c38181ef4d352762' : '60cb6016ec1b14930d4ba92f'
                },
                {
                    name: 'Ready-to-wear',
                    sceneId: variables.storeId === singaporeStoreId ? '620d2898c38181ef4d35276b' : '60f0abdbc584ff71d102ca9c'
                },
                {
                    name: 'Shoes',
                    sceneId: variables.storeId === singaporeStoreId ? '620d2898c38181ef4d352769' : '60cb6033d62abcc1c20006b9'
                },
                variables.storeId !== singaporeStoreId &&
                {
                    name: 'Fitting Room',
                    sceneId: '60f0ad44f2e43cc4d45f726b'
                }
            ]
        },
        variables.storeId !== singaporeStoreId &&
        {
            name: 'SPHERE',
            sceneId: '60cb5fe9ec1b14930d4ba92e',
            isHeader: true,
            haveItems: false,
        },
        variables.storeId !== singaporeStoreId &&
        {
            name: 'LOUNGE',
            sceneId: '60f0aa36f2e43cc4d45f7268',
            isHeader: true,
            haveItems: false,
        },
        variables.storeId !== singaporeStoreId &&
        {
            name: '57<sup>th</sup> STREET WINDOWS',
            sceneId: '60f1a72cf2e43cc4d45f7573',
            isHeader: true,
            haveItems: false,
        },
        variables.storeId === singaporeStoreId &&
        {
            name: 'KIDS',
            sceneId: '6213df330b6a1d285d429e28',
            isHeader: true,
            haveItems: false,
        },
    ]

    return menuList;
}

export function getFloorMenu() {
    const storeId = variables.storeId;
    let menuData = [
        {
            name: 'LEVEL 1',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/fendi/fendi-level1-map.svg",
                    pins: [
                        {
                            name: '', // Women's Shoes
                            sceneId: '60f09dd0f2e43cc4d45f71ea',
                            x: '105',
                            y: '55'
                        },
                        {
                            name: '', // Women's Bag's & Accessories
                            sceneId: '60cb5c64ec1b14930d4ba92b',
                            x: '160',
                            y: '215'
                        }
                    ]
                }
            ]
        },
        {
            name: 'LEVEL 2',
            sceneId: '',
            isHeader: true,
            haveItems: true,
            submenu: [
                {
                    name: '1',
                    imageUrl: "https://cdn.obsess-vr.com/fendi/fendi-level2-map.svg",
                    pins: [
                        {
                            name: '', // Men's Shoes
                            sceneId: '60cb6033d62abcc1c20006b9',
                            x: '253',
                            y: '150'
                        },
                        {
                            name: '', // Men's Ready to Wear
                            sceneId: '60f0abdbc584ff71d102ca9c',
                            x: '212',
                            y: '169'
                        },
                        {
                            name: '', // Lounge
                            sceneId: '60f0aa36f2e43cc4d45f7268',
                            x: '156',
                            y: '168'
                        },
                        {
                            name: '', // Women's Ready to Wear
                            sceneId: '60f0a630c584ff71d102ca97',
                            x: '86',
                            y: '166'
                        },
                        {
                            name: '', // Sphere
                            sceneId: '60cb5fe9ec1b14930d4ba92e',
                            x: '19',
                            y: '154'
                        },
                        {
                            name: '', // Men's Bag's & Accessories
                            sceneId: '60cb6016ec1b14930d4ba92f',
                            x: '175',
                            y: '118'
                        },
                        {
                            name: '', // Women's Bags & Accessories
                            sceneId: '60f0a7c1f2e43cc4d45f7262',
                            x: '98',
                            y: '130'
                        }
                    ]
                }
            ]
        }
    ];

    return menuData;
}
